import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';

import { Svg } from '@components/svg/Svg';

import { getEventImageSrcSet } from '@common/utils/event';
import { SupabaseEventRecord } from '@interfaces';

import styles from './listing-detail-artwork.module.scss';

interface ListingDetailArtworkProps {
	event: SupabaseEventRecord;
	className?: string;
}

export const ListingDetailArtwork = ({
	event,
	className,
}: ListingDetailArtworkProps) => {
	const audioRef = useRef<HTMLAudioElement>(null);
	const [isPreviewPlaying, setIsPreviewPlaying] = useState(false);

	const onClick = () => {
		if (!audioRef.current) return;

		if (audioRef.current.paused) {
			setIsPreviewPlaying(true);
		} else {
			audioRef.current.pause();
		}

		setIsPreviewPlaying(!audioRef.current.paused);
	};

	const onEnded = () => {
		setIsPreviewPlaying(false);
	};

	useEffect(() => {
		if (audioRef.current) {
			audioRef.current.addEventListener('ended', onEnded);
		}

		return () => {
			if (audioRef.current) {
				audioRef.current.removeEventListener('ended', onEnded);
			}
		};
	}, [audioRef]);

	return (
		<div
			className={classNames(className, styles['listing-detail-artwork'], {
				[styles['listing-detail-artwork--is-club']]: event.type === 'club',
			})}
		>
			{event.image_urls.length ? (
				<figure
					className={classNames(styles['listing-detail-artwork__figure'], {
						[styles['listing-detail-artwork__figure--dice']]:
							event.provider === 'dice',
					})}
				>
					<img
						alt=""
						height={800}
						itemProp="image"
						loading="lazy"
						sizes="(min-width: 56.25em) calc((100vw - 8rem) * 0.3125), (min-width: 34em) 34rem, 100vw"
						src={event.image_urls[0]}
						srcSet={getEventImageSrcSet(event.image_urls)}
						width={800}
					/>
				</figure>
			) : null}
			{event.track_preview_url ? (
				<button
					className={styles['listing-detail-artwork__audio']}
					onClick={onClick}
					type="button"
				>
					<Svg id={isPreviewPlaying ? 'pause' : 'play'} />
					Vibe check
					<audio preload="auto" ref={audioRef} src={event.track_preview_url} />
				</button>
			) : null}
		</div>
	);
};
